import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormControl, NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, T4Image, ImageType, ProductInfo } from 't4core';
import * as uuid from 'uuid';
import { ProductPriceInfo } from '../../../../../projects/t4core/src/public-api';

@Component({
  selector: 'AddSubscriptionDialog',
  templateUrl: 'AddSubscriptionDialog.html',
  styleUrls: ['./AddSubscriptionDialog.css']
})
export class AddSubscriptionDialogComponent extends DialogBase {

  constructor(
    public dialogRef: MatDialogRef<AddSubscriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("AddSubscriptionDialog");

  }

  public products: ProductInfo[];
  public productPrices : ProductPriceInfo[];
  public price: number = 0;
  public type: string;
  public loading: boolean = false;

  public selectedProduct: ProductInfo;

  public async ngOnInit() {
    this.loading = true;

    this.products = await this.Api.get<ProductInfo[]>("CC/GetProducts", {});;
    this.productPrices = await this.Api.post<ProductPriceInfo[]>("CC/GetActualProductPrices", null, { contextId: this.data.ContextId });

    this.loading = false;
  }


  public getPrice() {
    const selectedId = this.selectedProduct?.Id;

    const match = this.productPrices?.find(p => p.ProductId === selectedId);

    this.price = match?.Price ?? 0;

    const typeLabels: Record<number, string> = {
      0: "Fixed",
      1: "Percentage",
      2: "Specified",
      3: "FixedPerUnit",
    };

    if (match && match.Type in typeLabels) {
      this.type = typeLabels[match.Type];
    } else {
      this.type = "Unknown";
    }
  }


  public async save() {
    const result = await this.Api.post<any>("TurboOrder/CreateSubscription", null, { contextId: this.data.ContextId, productId: this.selectedProduct.Id })
    console.log(result);

    if (result) {
      this.dialogRef.close(true);
    }
  }



}
